import React, { useState } from "react";
import { useNavigate } from "react-router";

import {
  LayoutDashboard,
  ShoppingCart,
  Image,
  Plus,
  Grid3X3,
  Shapes,
  Users,
  ChevronRight,
} from "lucide-react";

const Sidebar = () => {
  const [activeItem, setActiveItem] = useState("/businessDash");
  const navigate = useNavigate();
  const menuItems = [
    { to: "/", label: "Dashboard", icon: LayoutDashboard },
    { to: "/orders", label: "Orders", icon: ShoppingCart },
    { to: "/banner", label: "Banner", icon: Image },
    { to: "/addproduct", label: "Add Product", icon: Plus },
    { to: "/categories", label: "Categories", icon: Grid3X3 },
    { to: "/dieshapes", label: "Die Shapes", icon: Shapes },
    { to: "/users", label: "Users", icon: Users },
  ];

  const handleItemClick = (path) => {
    navigate(path);
  };

  return (
    <aside className="bg-gradient-to-b from-slate-900 to-slate-800 text-white w-64 h-screen flex flex-col shadow-2xl border-r border-slate-700">
      {/* Header */}
      <div className="p-6 border-b border-slate-700">
        <button
          onClick={() => handleItemClick("/businessDash")}
          className={`group relative flex items-center justify-between px-4 py-3 rounded-xl transition-all duration-300 transform hover:scale-105 w-full text-left ${
            activeItem === "/businessDash"
              ? "bg-gradient-to-r from-blue-600 to-purple-600 shadow-lg shadow-blue-500/25"
              : "bg-slate-800/50 hover:bg-slate-700/70 border border-slate-600/50 hover:border-slate-500"
          }`}
        >
          <div className="flex items-center space-x-3">
            <LayoutDashboard
              size={18}
              className={`transition-transform duration-300 group-hover:rotate-6`}
            />
            <span className="font-semibold text-sm">B2B Dashboard</span>
          </div>
          <ChevronRight
            size={16}
            className="opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          />
        </button>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-4 py-6 space-y-2 overflow-y-auto">
        <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-4 px-2">
          Management
        </p>

        {menuItems.map((item) => {
          const IconComponent = item.icon;
          return (
            <button
              key={item.to}
              onClick={() => handleItemClick(item.to)}
              className={`group relative flex items-center space-x-3 px-4 py-3 rounded-xl transition-all duration-300 transform hover:translate-x-1 w-full text-left ${
                activeItem === item.to
                  ? "bg-gradient-to-r from-blue-600/20 to-purple-600/20 border-l-4 border-blue-500 text-blue-300 shadow-lg"
                  : "hover:bg-slate-700/50 text-slate-300 hover:text-white"
              }`}
            >
              <div className="relative">
                <IconComponent
                  size={18}
                  className="transition-all duration-300 group-hover:scale-110 group-hover:rotate-3"
                />
                <div className="absolute inset-0 bg-blue-500 rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-300 blur-sm"></div>
              </div>
              <span className="font-medium text-sm">{item.label}</span>

              {/* Hover indicator */}
              <div className="absolute right-2 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-x-2 group-hover:translate-x-0">
                <ChevronRight size={14} className="text-slate-400" />
              </div>
            </button>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-slate-700">
        <div className="bg-gradient-to-r from-slate-800 to-slate-700 rounded-lg p-3 border border-slate-600">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center">
              <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
            </div>
            <div>
              <p className="text-xs font-medium text-slate-300">
                System Status
              </p>
              <p className="text-xs text-green-400">All systems operational</p>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
